<template>
  <div class="main">
    <span class="serviceItem" v-for="(item, index) in links" @mouseenter.native="mouseEnter(index)" @mouseleave.native="mouseLeave(index)">
      <!--<references ref="reference" :content="item.detail" @referencesClick="referencesClick"/>-->
      <div class="reference" ref="reference" v-show="currentService === index" @dblclick="dbReference(item.paperLink)">{{item.detail}}</div>
      <span class="left"></span>
      <span class="right" @click="toLink(item.link)">{{item.name}}</span>
    </span>
  </div>
</template>

<script>

 import References from "./References";
 import { ref, reactive, getCurrentInstance, onMounted } from 'vue';
 import { useStore } from 'vuex'
  export default {
    name: "ServiceItem",
    components:{
      References,
    },
    props:{
      links:{
        type: Array,
        default: [],
      }
    },
    emits:['toLink'],
    setup(props, context){

      // data
      let store = useStore();
      let instance = reactive({});
      instance = getCurrentInstance();
      // references显示与隐藏
      let isShow = ref(false)
      let currentService = ref(-1)


      function toLink(link) {
        context.emit('toLink', link)
      }
      function mouseEnter(index) {
        currentService.value = index
        isShow.value = true
      }
      function mouseLeave(index) {
        currentService.value = -1
        isShow.value = false
      }
      function dbReference(addr) {
        if (addr !== '')
          //console.log(store.state.uploadFile + addr)
          location.href = store.state.uploadFile + addr;
      }

      return{ toLink, isShow, currentService,
        mouseEnter, mouseLeave, dbReference,
      }
    }
  }
</script>

<style scoped lang="less">

  .serviceItem{
    position: relative;

    .reference{
      z-index: 9;
      position: absolute;
      top: 80px;
      width: 360px;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
    }

    display: inline-block;
    padding: 10px 20px;
    width: 360px;
    height: 50px;
    line-height: 50px;
    margin: 0 25px 30px 25px;
    border: 3px solid #d3ecdd;
    font-size: 18px;
    color: #333;
    text-align: center;
    //float: left;
    cursor: pointer;

    .left{
      width: 20px;
      height: 20px;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -10px;
      margin-left: -3px;
      background: #24a056;
    }

    .right{
      display: inline-block;
      width: 360px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow:ellipsis;
    }

  }

</style>